<mat-form-field appearance="outline" class="w-100">
	<mat-label>{{ placeholder }}</mat-label>
	<mat-select required="true" [(value)]="selectedSingleOptions" (selectionChange)="onSingleFilterChanged($event)">
		<mat-option class="filter-option" *ngFor="let o of singleOptions" [value]="o.id">{{ o.name }}</mat-option>
	</mat-select>
</mat-form-field>
